var _path, _circle, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirImp6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.951 11.626L17.546 8.7a.318.318 0 00-.246-.116h-6.317a.318.318 0 00-.246.116L8.33 11.626a.287.287 0 00-.068.186v8.224a.31.31 0 00.315.302h11.124a.31.31 0 00.315-.302v-8.224a.272.272 0 00-.066-.186zm-.855-.066h-4.64V9.188h2.691l1.95 2.372zm-7.96-2.372h2.69v2.372h-4.64l1.95-2.372zM8.892 19.734v-7.57h10.495v7.57H8.893z",
    fill: "#2B2B2B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.14,
    cy: 13.843,
    r: 12.801,
    stroke: "#2B2B2B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.17,
    cy: 5.491,
    r: 4.949,
    fill: "#EEF0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.012 7.347h-1.67v-.406l.479-.178v-2.8l-.48-.184v-.407h1.671v.407l-.479.183v2.8l.479.179v.406zm4.104-3.073c.342 0 .598.087.769.262.174.174.261.456.261.846v1.965h-.701V5.516c0-.45-.171-.674-.513-.674-.245 0-.419.08-.523.24-.104.159-.156.391-.156.695v1.57h-.701V5.516c0-.45-.173-.674-.518-.674-.256 0-.433.09-.53.267-.096.178-.144.433-.144.763v1.475h-.7V4.33h.54l.1.395h.039a.788.788 0 01.373-.34c.163-.074.332-.11.507-.11.226 0 .415.038.567.116a.76.76 0 01.357.35h.055a.824.824 0 01.39-.356c.167-.074.344-.11.53-.11zm4.243 13.59h-.546v-3.092h1.754v.463h-1.208v.91h1.126v.463h-1.126v1.256zm3.101-2.668c-.283 0-.503.101-.659.303-.153.202-.23.477-.23.823 0 .35.073.624.217.823.145.196.367.294.667.294.13 0 .257-.013.381-.039.124-.028.254-.066.39-.112v.472c-.127.052-.255.09-.385.112a2.494 2.494 0 01-.442.035c-.318 0-.58-.065-.788-.195a1.198 1.198 0 01-.464-.554 2.15 2.15 0 01-.151-.84c0-.312.056-.586.169-.823a1.3 1.3 0 01.493-.563c.22-.136.487-.204.802-.204.155 0 .308.02.459.057.153.034.295.083.428.147l-.19.455a3.236 3.236 0 00-.342-.13 1.068 1.068 0 00-.355-.06zm1.432 2.668v-3.092h.554v2.624h1.29v.468h-1.844z",
    fill: "#2B2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirImp6);
export default __webpack_public_path__ + "static/media/air_imp_6.e4d1fafbd2d82c5be833b93d25aba429.svg";
export { ForwardRef as ReactComponent };